export default __webpack_public_path__ + "static/media/app-camara.dd2f3b1e.jpeg";